import CloseIcon from '@/assets/icons/x-icon-green-v2.svg';
import MuiChip, { ChipProps } from '@mui/material/Chip';

interface IProps extends ChipProps {
    clearable?: boolean;
}

export const Chip = ({ clearable = false, color = 'primary', size = 'medium', ...props }: IProps) => {
    return <MuiChip color={color} size={size} {...props} deleteIcon={clearable ? <img  src={CloseIcon}/> : <></>} />;
};

export default Chip;
